/**
 * Module Auto-Discovery System
 *
 * This file handles automatic module instantiation based on data-module attributes.
 * When you add a new module, import it here and add it to the modules object.
 *
 * Usage in HTML:
 * <div data-module="parallax">...</div>
 * <div data-module="text">...</div>
 */

// Import your modules here
import { Alpha } from "../alpha";
import { Parallax } from "../parallax";
import { Fade } from "../fade";
import { Group } from "../group";
import { Logo } from "../logo";
import { OppositeScroll } from "../oppositescroll";
import { Par } from "../par";
import { Scale } from "../scale";
import { Text } from "../text";
import { Reveal } from "../reveal";
import { BeforeAfterModal } from "../beforeaftermodal";
import { Nav } from "../nav";
import { Slider } from "../slider";
import { FlickerText } from "../flickertext";
import { ContactForm } from "../contactform";

// Add more module imports as you create them:
// import { Slider } from "../slider";
// import { Gallery } from "../gallery";

// Register modules by their data-module attribute name
const modules = {
  text: Text,
  parallax: Parallax,
  fade: Fade,
  scale: Scale,
  oppositescroll: OppositeScroll,
  group: Group,
  logo: Logo,
  par: Par,
  reveal: Reveal,
  beforeaftermodal: BeforeAfterModal,
  nav: Nav,
  slider: Slider,
  flickertext: FlickerText,
  contactform: ContactForm,
  // Add more modules here:
  // slider: Slider,
  // gallery: Gallery,
};

/**
 * Creates module instances for all elements with data-module attributes
 * @param {string} dataAttribute - The data attribute to look for (default: "module")
 * @returns {Array} Array of instantiated module instances
 */
export function createModules(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const moduleName = element.dataset[dataAttribute];
      const ModuleClass = modules[moduleName];

      if (ModuleClass) {
        try {
          return new ModuleClass(element);
        } catch (error) {
          console.warn(
            `Failed to instantiate ${dataAttribute} "${moduleName}":`,
            error
          );
          return null;
        }
      } else {
        console.warn(`Module not found: "${moduleName}". Make sure it's imported and registered in modules/_/create.js`);
        return null;
      }
    })
    .filter((item) => item !== null);
}
